import { Button } from "components";
import { DataListType } from "../../types";
import { UseFormReturn } from "react-hook-form";
import { FormType } from "../../schemas";
import { Table } from "./Table";
import { Create } from "./Create";
import { useFilterStore } from "../../stores";

type Props = {
    data: DataListType[]
    isLoading: boolean
    method: UseFormReturn<FormType>
    refecth: () => void
    refecthCode: () => void
}

export function ContentSection({
    data,
    isLoading,
    method,
    refecth,
    refecthCode
}: Props) {

    const { filter, setFilter } = useFilterStore();


    return (
        <div>
            <div className="flex justify-end mb-2">
                <Button
                    color="primary"
                    onClick={() => {

                        setFilter({
                            ...filter,
                            type: "prev"
                        })
                        refecth();
                    }}

                    disabled={!filter.date_start || !filter.date_end}
                >
                    PREVIOUS
                </Button>

            </div>
            <div className="overflow-auto max-h-[calc(100svh-620px)]">
                <Table
                    data={data}
                    isLoading={isLoading}
                    method={method}
                    start_date={filter.date_start}
                    end_date={filter.date_end}
                />
            </div>

            <div className="mt-3 mb-3 flex justify-end">
                <Create
                    refecth={refecth}
                    refecthCode={refecthCode}
                />
            </div>
        </div>
    )
}